import { render, staticRenderFns } from "./MatchSettingPicker.vue?vue&type=template&id=3713d8f4"
import script from "./MatchSettingPicker.vue?vue&type=script&lang=js"
export * from "./MatchSettingPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports